import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const StaffAPI = {
	list: async (filtersData) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Staff",
			params: filtersData,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Staff/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getUserName: async (userName) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Staff/" + userName,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Staff",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Staff/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Staff/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	unitsList: async (filtersData) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/StaffUnits",
			params: filtersData,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getUnit: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/StaffUnits/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	createUnit: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/StaffUnits",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	updateUnit: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/StaffUnits/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteUnit: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/StaffUnits/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getCareer: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Staff/" + id + "/career",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	createCareer: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Staff/career",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	updateCareer: async (id, careerId, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Staff/" + id + "/career/" + careerId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteCareer: async (id, careerId) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Staff/" + id + "/career/" + careerId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
};
